'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * Helper object in case you don't use flow – the string values as an object
 * of the various {@link SortMode}s
 * @module sortMode
 * @enum {string}
 * @see SortMode
 * @readonly
 * @property {'none'} NONE No sorting applied, teaser will be listed in the
 *   order their data has been downloaded.
 * @property {'manual'} MANUAL Use the same order as passed into the props.
 * @property {'chronologically by creation date'} CHRONOLOGICALLY_BY_CREATION_DATE Order teasers in
 *   chronological order using their `first_published_at` timestamp.
 * @property {'reverse chronologically by creation date'} REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE Order teasers in
 *   reverse chronological order using their `first_published_at` timestamp.
 * @property {'chronologically by update date'} CHRONOLOGICALLY_BY_UPDATE_DATE Order teasers in
 *   chronological order using their `timestamp_updated_at` timestamp.
 * @property {'reverse chronologically by update date'} REVERSE_CHRONOLOGICALLY_BY_UPDATE_DATE Order teasers in
 *   reverse chronological order using their `timestamp_updated_at` timestamp.
 */
var sortMode = exports.sortMode = {
  NONE: 'none',
  MANUAL: 'manual',
  CHRONOLOGICALLY_BY_CREATION_DATE: 'chronologically by creation date',
  REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE: 'reverse chronologically by creation date',
  CHRONOLOGICALLY_BY_UPDATE_DATE: 'chronologically by update date',
  REVERSE_CHRONOLOGICALLY_BY_UPDATE_DATE: 'reverse chronologically by update date'
};

/**
 * The possible string values that can be used to sort the articles.
 */
exports.default = sortMode;


//////////////////
// WEBPACK FOOTER
// ./~/@ta-interaktiv/react-article-teasers/dist/sortMode.js
// module id = 44
// module chunks = 0